import {
  MutationFunction,
  MutationKey,
  useMutation,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { CapturedApiError } from '../../errorHandling/errorHandling.types';
import { ReactQueryHandlerOptions } from './reactQuery.interfaces';
import { useQueryHandler } from './useQueryHandler';

export function useReactMutation<
  TData = unknown,
  TVariables = void,
  TContext = unknown
>(
  mutationKey: MutationKey,
  mutationFn: MutationFunction<TData, TVariables>,
  options?: Omit<
    UseMutationOptions<TData, CapturedApiError, TVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
  globalApiHandlerOptions?: ReactQueryHandlerOptions
): UseMutationResult<TData, CapturedApiError, TVariables, TContext> {
  const dispatch = useDispatch();
  const queryHandler = useQueryHandler(
    mutationFn,
    dispatch,
    globalApiHandlerOptions
  );
  const mutation = useMutation(
    mutationKey,
    (...args) => queryHandler(args),
    options
  );

  return mutation;
}
